// extracted by mini-css-extract-plugin
export default {"container":"RelatedCoursesEditor_container__cJMsL","item":"RelatedCoursesEditor_item__y4Zdl","dragClass":"RelatedCoursesEditor_dragClass__1cffN"};